<template>
  <PageTemplate>
    <Loader v-if="!isLoaded"/>
    <div v-else>
      <div class="d-flex justify-content-between">
        <h6 class="element-header">
          {{ $t('report_sick_days.title') }}
        </h6>
      </div>

      <div class="element-box">
        <h5 class="form-header mb-4">
          {{ $t('report_sick_days.overview') }}
        </h5>

        <div class="holiday_user_data">
          <h5 class="pb-3">
            {{ userData?.fullName }}
          </h5>
          <div class="left_side">
            <div class="single_line">
              <p style="float: left; width: 400px;">
                Anzahl der angefragten Krankheitstage:
              </p>
              <p style="float: left; width: 30px; text-align: right">
                {{ countTotalRequest }}
              </p>
            </div>
            <div class="clearfix"></div>

            <div class="single_line">
              <p style="float: left; width: 400px;">
                Anzahl der genehmigten Anträge auf Krankheitstage:
              </p>
              <p style="float: left; width: 30px; text-align: right">
                {{ countApprovedRequest }}
              </p>
            </div>
            <div class="clearfix"></div>

            <div class="single_line">
              <p style="float: left; width: 400px;">
                Anzahl der abgelehnten Anträge auf Krankheitstage:
              </p>
              <p style="float: left; width: 30px; text-align: right">
                {{ countDeclinedRequest }}
              </p>
            </div>
          </div>
        </div>

        <div class="row align-items-center justify-content-end mt-5" v-if="!overviewUserId">
          <button type="button" class="btn btn-outline-primary" @click="handleFormReportSickDay(null)">
            {{ $t('report_sick_days.create') }}
          </button>
        </div>

        <div class="table-responsive overflow-auto mt-4">
          <table class="table table-striped">
            <thead>
            <tr>
              <th>Mitarbeiternr</th>
              <th>Vorname</th>
              <th>Nachname</th>
              <th>Start</th>
              <th>Ende</th>
              <th class="text-end">Anzahl der Tage</th>
              <th class="text-center">eAU</th>
              <th class="text-center">Arzttermin vereinbart</th>
              <th class="text-center">Status</th>
              <th class="text-center">HR Bestätigungsstatus</th>
              <th class="text-center">Standortleiter Bestätigungsstatus</th>
              <th style=" text-align: right; padding-right: 30px; min-width: 150px;">{{ $t('general.actions') }}</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(report, index) in reportedSickDays" :key="report.id">
              <td>{{ report.user.employeeNumber }}</td>
              <td>{{ report.user.firstName }}</td>
              <td>{{ report.user.lastName }}</td>
              <td>{{ report.startDate }}</td>
              <td>{{ report.endDate }}</td>
              <td class="text-end">{{ report.numberOfDays }}</td>
              <td>{{ report.eAu === 1 ? 'ja' : 'nein' }}</td>
              <td>{{ report.doctorsAppointmentDate }}</td>
              <td class="text-center">
                <div class="d-flex align-items-center">
                  <div v-if="report.status === 'pending'"
                       class="status-pill yellow p-2 me-2" data-title="{{report.statusTranslation}}"
                       data-bs-toggle="tooltip">
                  </div>
                  <span v-if="report.status === 'pending'">{{ report.statusTranslation }}</span>
                </div>
                <div class="d-flex align-items-center">
                  <div v-if="report.status === 'approved'"
                       class="status-pill green p-2 me-2" data-title="{{report.statusTranslation}}"
                       data-bs-toggle="tooltip">
                  </div>
                  <span v-if="report.status === 'approved'">{{ report.statusTranslation }}</span>
                </div>
                <div class="d-flex align-items-center">
                  <div v-if="report.status === 'declined'"
                       class="status-pill red p-2 me-2" data-title="{{report.statusTranslation}}"
                       data-bs-toggle="tooltip">
                  </div>
                  <span v-if="report.status === 'declined'">{{ report.statusTranslation }}</span>
                </div>
              </td>

              <td class="text-center">
                <div class="ps-3 d-flex align-items-center">
                  <template v-if="report.oldLogic">
                    <div class="status-pill green p-2 me-2"
                         data-title="Genehmigt"
                         data-bs-toggle="tooltip"></div>
                    <span v-if="report.deleted">Abgelehnt</span>
                    <span v-else>Genehmigt</span>
                  </template>

                  <template v-else>
                    <template v-if="report.hrApprove === null">
                      <div class="status-pill yellow p-2 me-2"
                           data-title="Anstehend"
                           data-bs-toggle="tooltip"></div>
                      Anstehend
                    </template>

                    <template v-else-if="report.hrApprove === true">
                      <div class="status-pill green p-2 me-2"
                           data-title="Genehmigt"
                           data-bs-toggle="tooltip"></div>
                      Genehmigt
                    </template>

                    <template v-else-if="report.hrApprove === false">
                      <div class="status-pill red p-2 me-2"
                           data-title="Abgelehnt"
                           data-bs-toggle="tooltip"></div>
                      Abgelehnt
                    </template>
                  </template>
                </div>
              </td>

              <td class="text-center">
                <div class="ps-3 d-flex align-items-center">
                  <template v-if="report.oldLogic">
                    <div class="status-pill green p-2 me-2"
                         data-title="Genehmigt"
                         data-bs-toggle="tooltip"></div>
                    <span v-if="report.deleted">Abgelehnt</span>
                    <span v-else>Genehmigt</span>
                  </template>

                  <template v-else>
                    <template v-if="report.coordinatorApprove === null">
                      <div class="status-pill yellow p-2 me-2"
                           data-title="Anstehend"
                           data-bs-toggle="tooltip"></div>
                      Anstehend
                    </template>

                    <template v-else-if="report.coordinatorApprove === true">
                      <div class="status-pill green p-2 me-2"
                           data-title="Genehmigt"
                           data-bs-toggle="tooltip"></div>
                      Genehmigt
                    </template>

                    <template v-else-if="report.coordinatorApprove === false">
                      <div class="status-pill red p-2 me-2"
                           data-title="Abgelehnt"
                           data-bs-toggle="tooltip"></div>
                      Abgelehnt
                    </template>
                  </template>
                </div>
              </td>
              <td class="text-end">
                <div v-if="overviewUserId">
                  <ActionsButton
                      :isOpen="openIndex === index"
                      :report="report"
                      :approveLabel="t('general.approve')"
                      :approveAsAdminLabel="t('general.approve_as_admin')"
                      :approveAsCoordinatorLabel="t('general.approve_as_coordinator')"
                      :userRole="piniaCurrentUser.roles[0]"
                      @approveRequest="approveRequest"
                      @declineRequest="declineRequest"
                      @toggle="toggleDropdown(index)"/>
                </div>
                <div v-else>
                  <button class="btn btn-primary ms-2"
                          @click="handleFormReportSickDay(report?.id)">
                    <i class="os-icon os-icon-trash"></i>
                  </button>
                  <button class="btn btn-danger ms-2"
                          @click="handleDeleteSickDay(report?.id)">
                    <i class="os-icon os-icon-trash"></i>
                  </button>
                </div>
              </td>
            </tr>
            </tbody>
          </table>

        </div>
      </div>
    </div>

    <Modal
        v-model="showModalForm"
        :title="$t('report_sick_days.create')"
        :hide-cancel="true"
        :button-label="$t('general.button.save')"
        sizeModal="modal-xl"
        :hide-footer="true"
        classFooter="justify-content-center">
      <Form
          :reportedSickDaysId="reportedSickDaysId"
          v-model:submitForm="submitForm"/>
    </Modal>

    <ModalConfirm
        v-model="showApproveRequestConfirm"
        :header="approveHeader"
        :onConfirm="confirmApproveRequest"/>

    <ModalDecline
        v-model="showDeclineRequestConfirm"
        :confirmationQuestion="t('general.decline_question')"
        header=""
        :onConfirm="confirmDeclineRequest"/>

    <ModalDelete
        v-model="showModalDelete"
        :header="t('general.delete_item_header')"
        :onDelete="confirmDeleteSickDay">
    </ModalDelete>
  </PageTemplate>
</template>


<script setup>
import reportSickDaysService from '@/api/ReportSickDays';
import Loader from '@/components/Loader.vue';
import Modal from '@/components/modal/Modal.vue';
import ModalConfirm from '@/components/modal/ModalConfirm.vue';
import ModalDecline from '@/components/modal/ModalDecline.vue';
import ModalDelete from '@/components/modal/ModalDelete.vue';
import PageTemplate from '@/components/PageTemplate.vue';
import { CloseToast, ErrorToast, SuccessToast } from '@/components/VueToast';
import { piniaUserStore } from '@/store/piniaUserStore';
import ActionsButton from '@/views/App/ReportSickDays/V2/ActionButon.vue';
import Form from '@/views/App/ReportSickDays/V2/Form.vue';
import { computed, onMounted, ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute } from 'vue-router';

const { t }   = useI18n();
const filters = ref({
  clientId: '',
  officeId: '',
});

const piniaUserState            = piniaUserStore();
const piniaCurrentUser          = computed(() => piniaUserState.currentUser.user);
const route                     = useRoute();
const overviewUserId            = route.params.overviewUserId;
const userData                  = ref(null);
const reportedSickDays          = ref([]);
const countTotalRequest         = ref(0);
const countApprovedRequest      = ref(0);
const countDeclinedRequest      = ref(0);
const reportedSickDaysId        = ref(null);
const showModalDelete           = ref(false);
const showModalForm             = ref(false);
const isLoaded                  = ref(false);
const submitForm                = ref(false);
const openIndex                 = ref(null);
const requestData               = ref({});
const approveHeader             = ref('');
const showApproveRequestConfirm = ref(false);
const showDeclineRequestConfirm = ref(false);

watch(submitForm, () => {
  showModalForm.value      = false;
  showModalDelete.value    = false;
  reportedSickDaysId.value = null;
  getOverviewData();
});

watch(showApproveRequestConfirm, () => {
  if (!showApproveRequestConfirm.value) {
    toggleDropdown();
  }
});

watch(showDeclineRequestConfirm, () => {
  if (!showDeclineRequestConfirm.value) {
    toggleDropdown();
  }
});

function generateApproveHeader(approveBy) {
  if (approveBy === 'admin') {
    approveHeader.value = t('general.approve_as_admin');
  } else if (approveBy === 'coordinator') {
    approveHeader.value = t('general.approve_as_coordinator');
  } else {
    approveHeader.value = t('general.approve');
  }
}

const toggleDropdown = (index) => {
  openIndex.value = openIndex.value === index ? null : index;
};

async function getOverviewData() {
  try {
    const { data } = await reportSickDaysService.getUserOverviewDataV2(String(overviewUserId));

    userData.value             = data?.data?.user;
    reportedSickDays.value     = data?.data?.reportedSickDays;
    countTotalRequest.value    = data?.data?.countTotalRequest;
    countApprovedRequest.value = data?.data?.countApprovedRequest;
    countDeclinedRequest.value = data?.data?.countDeclinedRequest;

  } catch (error) {
    await ErrorToast(error);
  }
}

function handleFormReportSickDay(id) {
  CloseToast();
  reportedSickDaysId.value = id;
  showModalDelete.value    = false;
  showModalForm.value      = true;
}

function handleDeleteSickDay(id) {
  CloseToast();
  reportedSickDaysId.value = id;
  showModalDelete.value    = true;
  showModalForm.value      = false;
}

function approveRequest(requestId, approveBy) {
  CloseToast();

  requestData.value = {
    requestId,
    approveBy,
  };

  generateApproveHeader(approveBy);
  showApproveRequestConfirm.value = true;
  showDeclineRequestConfirm.value = false;
}

async function confirmApproveRequest() {
  try {
    await reportSickDaysService.approveRequestV2(
        requestData.value.requestId,
        requestData.value.approveBy,
    );

    showDeclineRequestConfirm.value = false;
    showApproveRequestConfirm.value = false;
    toggleDropdown();
    await getOverviewData();
    SuccessToast(t('general.toasts.save_success'));
  } catch (error) {
    await ErrorToast(error);
  }
}

function declineRequest(requestId) {
  CloseToast();

  requestData.value = {
    requestId,
  };

  showDeclineRequestConfirm.value = true;
  showApproveRequestConfirm.value = false;
}

async function confirmDeclineRequest() {
  try {
    await reportSickDaysService.declineRequestV2(requestData.value.requestId);

    showDeclineRequestConfirm.value = false;
    showApproveRequestConfirm.value = false;
    toggleDropdown();
    await getOverviewData();
    SuccessToast(t('general.toasts.save_success'));
  } catch (error) {
    await ErrorToast(error);
  }
}

async function confirmDeleteSickDay() {
  try {
    await reportSickDaysService.deleteReportedSickDaysV2(reportedSickDaysId.value);

    filters.value.userId    = '';
    filters.value.startDate = '';
    filters.value.endDate   = '';
    filters.value.thisWeek  = false;
    showModalDelete.value   = false;

    await getOverviewData();
    SuccessToast(t('general.toasts.delete_success'));
  } catch (error) {
    await ErrorToast(error);
  }
}

onMounted(async () => {
  CloseToast();

  await Promise.all([
    getOverviewData(),
  ]);

  isLoaded.value = true;
});

</script>

<style scoped>

</style>